export default __webpack_public_path__ + "static/qr-shop-xiaohongshu-19bc557dac4a2746a839a3c43157e7d6.png";